module.exports = __webpack_public_path__ + "assets/img/piggy.da46d4d3.png";